var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { currentUserState } from '@/presentation/components';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import useSystemAccount from '@/presentation/hooks/use-system-account';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
const AGE_DAY = 7;
// Function to generate an array of dates from 8 days ago to param date
function generateDates(mapDatesToLocalZone) {
    var _a;
    let dateMain = new Date();
    try {
        // find newest date in the array
        const findNewstDate = mapDatesToLocalZone === null || mapDatesToLocalZone === void 0 ? void 0 : mapDatesToLocalZone.reduce((acc, transaction) => {
            const date = transaction.created_at;
            if (acc < date)
                return date;
            return acc;
        }, (_a = mapDatesToLocalZone[0]) === null || _a === void 0 ? void 0 : _a.created_at);
        if (findNewstDate) {
            dateMain = new Date(findNewstDate);
        }
    }
    catch (error) {
        console.log(error);
    }
    console.log('dateMain:', dateMain);
    const dates = [];
    dates.push(dateMain.toLocaleDateString('en-US'));
    for (let i = 0; i < AGE_DAY; i++) {
        const date = dateMain;
        date.setDate(date.getDate() - 1);
        dates.push(date.toLocaleDateString('en-US'));
    }
    return dates;
}
const useMyWalletOverview = ({ manageVirtualTransactions, manageVirtualAccounts, manageUser }) => {
    const [openModalFunds, setOpenModalFunds] = useState(false);
    const [showCreditScore, setShowCreditScore] = useState(false);
    const [tableValues, setTableValues] = useState([]);
    const [dates, setDates] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [totalEarned, setTotalEarned] = useState(0);
    const [cashoutResponse, setCashoutResponse] = useState(null);
    const { getCurrentUser } = useRecoilValue(currentUserState);
    const currentUser = getCurrentUser();
    const { showCustomError } = useCustomToast();
    const { mainChecking } = useSystemAccount();
    const loadData = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const userAccountData = yield manageVirtualAccounts.getUserAccount((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.user) === null || _a === void 0 ? void 0 : _a.id);
            const userAccounts = () => {
                if (userAccountData) {
                    return userAccountData === null || userAccountData === void 0 ? void 0 : userAccountData.map(account => (account.accountType.id === 37 || account.accountType.id === 36) && account);
                }
                else {
                    return [];
                }
            };
            const accountsNumbers = userAccounts().map(account => account.id);
            yield getUserTotalEarnings([...accountsNumbers]);
            const getTransactions = yield manageVirtualTransactions.getDailyEarnings({
                ageDay: AGE_DAY,
                from: mainChecking === null || mainChecking === void 0 ? void 0 : mainChecking.id,
                to: [...accountsNumbers]
            });
            const mapDatesToLocalZone = getTransactions === null || getTransactions === void 0 ? void 0 : getTransactions.map(transaction => {
                const newDate = new Date(transaction.created_at);
                return {
                    amount: transaction.amount,
                    created_at: newDate.toLocaleDateString('en-US')
                };
            });
            const dates = generateDates(mapDatesToLocalZone);
            console.log('dates:', dates);
            const sumByDate = mapDatesToLocalZone.reduce((acc, transaction) => {
                var _a;
                const date = transaction.created_at;
                const amount = parseFloat(((_a = transaction === null || transaction === void 0 ? void 0 : transaction.amount) === null || _a === void 0 ? void 0 : _a.toString()) || '0');
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                acc[date] = (acc[date] || 0) + amount;
                return acc;
            }, {});
            const tableValues = [];
            const tableTitles = [];
            dates.reverse().forEach(date => {
                if (!sumByDate[date])
                    sumByDate[date] = 0;
                tableValues.push(sumByDate[date]);
                tableTitles.push(date);
            });
            setDates(tableTitles);
            setTableValues(tableValues);
        }
        catch (error) {
            console.log(error);
            showCustomError('Error', 'Error loading data');
        }
        finally {
            setIsLoading(false);
        }
    });
    const getUserTotalEarnings = (accountIds) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            const res = yield manageVirtualTransactions.getTotalEarnings({
                accountIds
            });
            if (!res) {
                setTotalEarned(0);
                return;
            }
            setTotalEarned(res);
        }
        catch (error) {
            console.log(error);
            showCustomError('Error', 'Error loading data');
        }
        finally {
            setIsLoading(false);
        }
    });
    const getStudentCashout = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            const res = yield manageUser.studentFindStudentCashout();
            if (res) {
                setCashoutResponse(res);
            }
        }
        catch (error) {
            console.log(error);
            showCustomError('Error', 'Error loading data');
        }
        finally {
            setIsLoading(false);
        }
    });
    useEffect(() => {
        loadData();
        getStudentCashout();
    }, []);
    return {
        openModalFunds,
        setOpenModalFunds,
        showCreditScore,
        setShowCreditScore,
        tableValues,
        setTableValues,
        dates,
        setDates,
        isLoading,
        setIsLoading,
        totalEarned,
        cashoutResponse,
        getStudentCashout
    };
};
export default useMyWalletOverview;
